import api from "../apiConfig";
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/variable?${p}`);
  },
  update(data) {
    return api.put(`/api/v1/variable/${data.id}`, data);
  },
  apkUpload(data) {
    return api.post(`/api/v1/update-version`, data);
  },
  apkGetVersion() {
    return api.get(`/api/v1/get-version`);
  },
};
